<div class="new-ui-row top">
  <p>
    {{'newUiModal.firstParagraph' | translate}}
  </p>
</div>
<div class="new-ui-row middle">
  <p>{{'newUiModal.contactUs' | translate}} <a href="mailto:info@dwall.online">info@dwall.online</a>.</p>
</div>
<div class="new-ui-row bottom">
  <p>{{'newUiModal.regards' | translate}},<br>
    {{'newUiModal.dwallTeam' | translate}}.</p>
</div>
<div class="buttons-wrap">
  <button type="button" mat-dialog-close class="dw-btn">{{'app.common.close' | translate}}</button>
</div>
